<template>
  <div class="collage-carousel">
    <div class="collage-grid">
      <!-- 🎀 SELLO DE LACRE CON IMAGEN ASSETS -->
      <img 
        src="@/assets/1942483b2f7cb66952d677750fe78c1d.png" 
        alt="Sello de lacre" 
        class="wax-seal" 
      />

      <div
        v-for="(image, index) in images"
        :key="index"
        ref="collageItems"
        class="collage-item"
        :class="['photo-' + (index + 1), { visible: imageVisible[index] }]"
        @click="enlargeImage(index)"
      >
        <!-- MARCO POLAROID -->
        <div class="polaroid-card">
          <div class="photo-wrapper">
            <img
              :src="image"
              class="collage-image"
              :alt="'Imagen ' + index"
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      v-if="isImageEnlarged"
      class="image-modal"
      @click="closeModal"
    >
      <img
        :src="images[currentIndex]"
        class="enlarged-image"
      >
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CollageAnimado',
  setup() {
    const images = [
   require('@/assets/IMG_1463.png'),
      require('@/assets/IMG_1469.png'),
      require('@/assets/IMG_1468.png'),
     
    ]

    const currentIndex = ref(0)
    const isImageEnlarged = ref(false)
    const collageItems = ref([])
    const imageVisible = ref(new Array(images.length).fill(false))

    const enlargeImage = (index) => {
      currentIndex.value = index
      isImageEnlarged.value = true
    }

    const closeModal = () => {
      isImageEnlarged.value = false
    }

    const observeImages = () => {
      const options = { threshold: 0.15 }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const index = collageItems.value.indexOf(entry.target)
          if (entry.isIntersecting && !imageVisible.value[index]) {
            imageVisible.value[index] = true
            animateIn(entry.target, index)
          }
        })
      }, options)

      collageItems.value.forEach((el) => observer.observe(el))
    }

    // ✨ ANIMACIÓN MÁGICA 3D CON GSAP
    const animateIn = (el, index) => {
      const rotations = [-6, 5, -4, 7, -5, 6, -3]
      const targetRotation = rotations[index % rotations.length]

      const fromX = (index % 2 === 0 ? -60 : 60)

      gsap.fromTo(
        el,
        {
          opacity: 0,
          y: -120,
          x: fromX,
          scale: 1.25,
          rotationX: 45,
          rotationY: index % 2 === 0 ? -25 : 25,
          rotation: targetRotation + (index % 2 === 0 ? -15 : 15),
          filter: 'drop-shadow(0 25px 20px rgba(0,0,0,0.3))'
        },
        {
          opacity: 1,
          y: 0,
          x: 0,
          scale: 1,
          rotationX: 0,
          rotationY: 0,
          rotation: targetRotation,
          filter: 'drop-shadow(0 10px 15px rgba(0,0,0,0.12))',
          duration: 1.6,
          delay: (index % 3) * 0.18,
          ease: 'power3.out'
        }
      )
    }

    onMounted(async () => {
      await nextTick()
      collageItems.value = collageItems.value.slice(0, images.length)
      observeImages()

      // 🎀 Animación para el sello de lacre
      gsap.fromTo('.wax-seal', 
        { scale: 0, opacity: 0, rotation: -90, y: -40 },
        { scale: 1, opacity: 1, rotation: 0, y: 0, duration: 1.2, delay: 0.6, ease: 'back.out(2)' }
      )
    })

    return {
      images,
      currentIndex,
      isImageEnlarged,
      enlargeImage,
      closeModal,
      collageItems,
      imageVisible,
    }
  }
}
</script>

<style scoped>
.collage-carousel {
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 90px 20px;
  box-sizing: border-box;
  margin-bottom: -40px;
}

/* GRID FLEXIBLE ESTILO COLLAGE */
.collage-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 25px;
  position: relative;
}

/* 🎀 SELLO LACRE DECORATIVO */
.wax-seal {
  position: absolute;
  top: -66px !important;
  left: 50%;
  transform: translateX(-50%);
  width: 225px !important;
  height: auto;
  z-index: 10;
  pointer-events: none;
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.25));
}

.collage-item {
  opacity: 0;
  cursor: pointer;
  perspective: 1200px;
  transition: z-index 0.3s ease;
  will-change: transform, opacity;
}

.collage-item.visible {
  opacity: 1;
}

/* MARCO TIPO POLAROID REALISTA */
.polaroid-card {
  background: #ffffff;
  padding: 12px 12px 38px 12px;
  border-radius: 4px;
  box-shadow: 
    0 10px 25px rgba(0, 0, 0, 0.12),
    0 4px 10px rgba(0, 0, 0, 0.06);
  transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.4s ease;
}

/* CONTENEDOR ESTÁNDAR DE IMÁGENES */
.photo-wrapper {
  width: 100%;
  height: 320px;
  overflow: hidden;
  background: #fdfdfd;
  display: flex;
  align-items: center;
  justify-content: center;
}

.collage-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center; 
  display: block;
}

/* 🔥 AJUSTE ESPECIAL EN PRIMERA FOTO PARA MOSTRARLA COMPLETA SIN MÁXIMO DE ALTURA CORTADO */
.photo-1 .photo-wrapper {
  height: auto !important;
  max-height: none !important;
}

.photo-1 .collage-image {
  height: auto !important;
  object-fit: contain !important;
}

/* HOVER: ELEVACIÓN ELEGANTE EN 3D */
.collage-item:hover {
  z-index: 30 !important;
}

.collage-item:hover .polaroid-card {
  transform: scale(1.06) translateY(-10px) rotate(0deg);
  box-shadow: 
    0 22px 40px rgba(0, 0, 0, 0.22),
    0 8px 16px rgba(0, 0, 0, 0.1);
}

/* 🎨 POSICIONAMIENTO Y ROTACIONES INDIVIDUALES PARA LAS 7 FOTOS */
.photo-1 {
  width: 280px;
  transform: rotate(-6deg);
  margin-right: -20px;
  z-index: 1;
}

.photo-2 {
  width: 290px;
  transform: rotate(5deg);
  margin-left: -20px;
  margin-top: -15px;
  z-index: 2;
}

.photo-3 {
  width: 285px;
  transform: rotate(-4deg);
  margin-top: 10px;
  z-index: 3;
}

.photo-4 {
  width: 295px;
  transform: rotate(7deg);
  margin-right: -25px;
  margin-top: -20px;
  z-index: 2;
}

.photo-5 {
  width: 290px;
  transform: rotate(-5deg);
  margin-left: -15px;
  z-index: 4;
}

.photo-6 {
  width: 285px;
  transform: rotate(6deg);
  margin-top: -10px;
  z-index: 3;
}

.photo-7 {
  width: 295px;
  transform: rotate(-3deg);
  margin-left: -10px;
  z-index: 5;
}

/* ADAPTACIÓN MÓVIL */
@media (max-width: 768px) {
  .wax-seal {
    width: 80px !important;
    top: -50px !important;
  }

  .photo-wrapper {
    height: 480px;
  }

  .photo-1, .photo-2, .photo-3, .photo-4, .photo-5, .photo-6, .photo-7 {
    width: 85vw;
    max-width: 320px;
    margin: -10px 0;
  }

  .photo-1 { transform: rotate(-3deg); }
  .photo-2 { transform: rotate(3deg); }
  .photo-3 { transform: rotate(-2deg); }
  .photo-4 { transform: rotate(4deg); }
  .photo-5 { transform: rotate(-3deg); }
  .photo-6 { transform: rotate(3deg); }
  .photo-7 { transform: rotate(-2deg); }
}

/* Modal */
.image-modal {
  position: fixed;
  inset: 0;
  background-color: rgba(10, 10, 10, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  backdrop-filter: blur(4px);
}

.enlarged-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 12px;
  object-fit: contain;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}
</style>